import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

export default function AutoSelect({
  id,
  options = [],
  values = [],
  descriptions = [],
  value: inValue,
  onChange,
  label,
  type,
  helperText = '',
  required = false,
  freeSolo = true,
  disabled = false,
  getOptionLabel,
  checkError = false,
}) {
  const [inputValue, setInputValue] = useState('');
  const [value, setValue] = useState('');
  const [errorMsg, setErrorMsg] = useState();

  useEffect(() => {
    if (typeof inValue !== 'undefined') {
      const matchedIndex = values.findIndex((v) => v === inValue);
      if (matchedIndex !== -1) {
        setValue(options[matchedIndex]);
        setInputValue(options[matchedIndex]);
        setErrorMsg();
        return;
      } else if (freeSolo) {
        setValue('');
        if (typeof inValue === 'number') {
          setInputValue(inValue.toString());
        } else {
          setInputValue(inValue);
        }
      }
      if (matchedIndex === -1 && checkError) {
        setErrorMsg('沒有符合的資料');
      }
    } else {
      setValue('');
      setInputValue('');
      setErrorMsg();
    }
  }, [inValue, values, options]);

  const renderInput = (params) => {
    return (
      <TextField
        {...params}
        type={type}
        label={label}
        required={required}
        InputLabelProps={{
          shrink: true,
        }}
        error={!!errorMsg}
        helperText={errorMsg || helperText}
        inputProps={Object.assign(params.inputProps, {
          value: inputValue,
        })}
        disabled={disabled}
      />);
  };

  return (
    <Autocomplete
      id={id}
      options={options}
      freeSolo={freeSolo}
      value={value || ''}
      getOptionLabel={getOptionLabel}
      required={required}
      onChange={(event, newItem) => {
        if (newItem) {
          const matchedIndex = options.findIndex((label) => label === newItem);
          if (matchedIndex === -1 && checkError) {
            setErrorMsg('沒有符合的資料');
          }
          if (matchedIndex !== -1) {
            setErrorMsg();
          }
          onChange(values[matchedIndex]);
        } else if (freeSolo) {
          onChange(newItem === null ? undefined : newItem); // 不要return null, 因為null有機會對應到'無'，會造成reset時跳出'無'
        }
      }}
      inputValue={inputValue || ''}
      onInputChange={(event, newInputValue, reason) => {
        if (reason === 'reset') return;

        setInputValue(newInputValue);

        if (newInputValue) {
          const matchedIndex = type === 'number' ?
            values.findIndex((value) => value === newInputValue):
            options.findIndex((label) => label === newInputValue);
          if (matchedIndex === -1 && checkError) {
            setErrorMsg('沒有符合的資料');
          }
          if (matchedIndex !== -1) {
            setErrorMsg();
            onChange(values[matchedIndex]);
          } else if (freeSolo) {
            onChange(newInputValue);
          }
        }
      }}
      renderInput={renderInput}
      disabled={disabled}
      renderOption={(option) => {
        const optionIndex = options.findIndex((item) => item === option);
        let description;
        if (optionIndex !== -1) {
          description = descriptions?.[optionIndex];
        }
        if (description) {
          return (
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <span style={{ flex: 1 }}>{option}</span>
              <span style={{ flex: 3, fontSize: '0.8em', marginLeft: 8, textAlign: 'right' }}>{description}</span>
            </div>
          );
        }
        return (
          <React.Fragment>
            {option}
          </React.Fragment>
        );
      }}
    />);
}


AutoSelect.propTypes = {
  id: PropTypes.string,
  options: PropTypes.array,
  values: PropTypes.array,
  descriptions: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  label: PropTypes.string,
  type: PropTypes.string,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  freeSolo: PropTypes.bool,
  disabled: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  checkError: PropTypes.bool,
};
